import React, { ComponentType, ReactNode } from 'react'
import { Transition } from '@headlessui/react'

type SmoothTransitionProps = {
  show: boolean
  children: ReactNode
}

export const SmoothTransition: ComponentType<SmoothTransitionProps> = ({
  show,
  children
}) => {
  return (
    <Transition
      show={show}
      enter="transition-opacity duration-300 ease-out"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-300 ease-in"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      className="smooth-transition"
    >
      {children}
    </Transition>
  )
}
